module.exports = __webpack_public_path__ + "img/suipian_bottom.13c69989.png";